// ------------------------------------
// props 輸入需求 : 
// props.setReset : function( params: boolean )         ( 回傳true --> 重刷畫面 )
// ------------------------------------


import React, { useState, useEffect, useLayoutEffect } from 'react'
import './_Login.scss'
import Dropdown from '../dropdown/Dropdown'
import { resources } from '../../i18n'
import { useTranslation } from "react-i18next"; // 1.1 i18n
import ApiGo from '../../actions/ApiGo';
import Account from '../../actions/Account';
import { useDispatch } from 'react-redux';
import FBSDK from './FBSDK';
import { GoogleSDKLogout } from './GoogleSDK';
import GoogleAuth from './GoogleSDK';
import { loginStore } from '../../comm_stores';
// import { LogInformation } from '../../actions/forFrontEnd_Log';

const date = new Date();
const year = date.getFullYear()
const markC = "©"
const Login = (props) => {
    const dispatch = useDispatch()
    const [width, height, width_ratio, height_ratio] = useWindowSize();
    const [thirdPartyTag, setThirdPartyTag] = useState(false);
    // i18n 組合
    const { t, i18n } = useTranslation(); // 1.2 i18n
    const lng_choice = Object.entries(resources).map(res => res[1].title)
    lng_choice.unshift(t('GLOBAL.CHANGE_LANGUAGE'))
    const DP_data = { id: lng_choice[0], keys: lng_choice }
    const [returnLng, setReturnLng] = useState(t('GLOBAL.CHANGE_LANGUAGE'));     //dropdown return result
    // language 存為預設
    function storeLanguageToStorage(lng) {
        localStorage.setItem("i18nextLng", lng)
        sessionStorage.setItem("i18nextLng", lng)
    }
    // language 修改
    useEffect(() => {
        let result = Object.entries(resources).filter(res => res[1].title === returnLng)[0]
        if (result !== undefined) {
            storeLanguageToStorage(result[0])
            i18n.changeLanguage(result[0])
        }
    }, [returnLng, i18n])
    // 帳密輸入組合
    const [account, setAccount] = useState("");
    const [password, setPassword] = useState("");
    const [clickAccount, setClickAccount] = useState(false);
    const [clickPassword, setClickPassword] = useState(false);

    // 輸入錯誤帳號密碼
    const [storeLogin, setStoreLogin] = useState(loginStore.getState());
    const [wrongAccOrPwd, setWrongAccOrPwd] = useState(false);
    loginStore.subscribe(() => setStoreLogin(loginStore.getState()));
    useEffect(() => {
        if (storeLogin.status === "denied") setWrongAccOrPwd(true)
    }, [storeLogin])
    // fetch api
    function login(event) {
        if (event.key === "Enter" || event === "Enter") {
            new Account().login(account, password)
        }
    }
    // dropdown 組合
    const [dropdown_open, setDropdown_open] = useState(false);
    function toggleDropdown() { setDropdown_open(!dropdown_open) }

    const [HEROimg, setHEROimg] = useState(null);
    const [LOGOimg, setLOGOimg] = useState(null);
    const [orign_HEROimgWH, setOrign_HEROimgWH] = useState([]);
    const [orign_LOGOimgWH, setOrign_LOGOimgWH] = useState([]);
    const [HEROimgWH, setHEROimgWH] = useState([]);
    const [LOGOimgWH, setLOGOimgWH] = useState([])

    useLayoutEffect(() => {
        if (HEROimg !== null) {
            setHEROimgWH([orign_HEROimgWH[0] * width_ratio, orign_HEROimgWH[1] * height_ratio])
        }
        if (LOGOimg !== null) {
            setLOGOimgWH([orign_LOGOimgWH[0] * width_ratio, orign_LOGOimgWH[1] * height_ratio])
        }
    }, [width, height, orign_HEROimgWH, orign_LOGOimgWH, width_ratio, height_ratio, HEROimg, LOGOimg])

    useLayoutEffect(() => {
        ApiGo.getInstitution_img()
            .then(res => {
                if (res.HeroImg.exist !== "") {
                    setHEROimg(res.HeroImg.exist)
                    setOrign_HEROimgWH([parseInt(res.HeroImg.width), parseInt(res.HeroImg.height)])
                }
                if (res.LogoImg.exist !== "") {
                    setLOGOimg(res.LogoImg.exist)
                    setOrign_LOGOimgWH([res.LogoImg.width, res.LogoImg.height])
                }
            })
            .catch((err) => {
                console.error(err);
            })
    }, [])
    // //  ------------------ user log ------------------
    // useEffect(()=>{
    //     new LogInformation("Login").recMount()
    //     return (e)=>{
    //     new LogInformation("Login").recUnmount()
    //     }
    // },[])
    // window.onerror = (e)=>{new LogInformation("Login").recError(e)}
    // //  ------------------ user log ------------------

    return (
        <div className="container-fluid">
            <div className="row hig-full">
                {/* 大圖 */}
                <div className="col-8">
                    <div className={`fx-d-c fx-ccc col-12 ${(width <= 1500) ? "pad-5 l r" : "pad-15 l r"}`}>
                        {/* <img src={common_images.LOGIN_IMG} className="w-100 img_crisp" alt='Brand' /> */}
                        {(HEROimg === null || HEROimg === undefined) ?
                            <div className='empty-heroImg font-l' data-content={t("GLOBAL.HEROIMG")}>
                                <div className='bdr-dashed lt'></div>
                                <div className='bdr-dashed rt'></div>
                                <div className='bdr-dashed lb'></div>
                                <div className='bdr-dashed rb'></div>
                            </div> :
                            <div className='login_img'>
                                <img src={HEROimg}
                                    style={{ width: `${HEROimgWH[0]}px`, height: `${HEROimgWH[1]}px` }}
                                    className="img_crisp "
                                    alt='Brand' />
                            </div>}
                    </div>
                </div>
                {/* 登入 */}
                <div className="col-4 hig-full fx-d-c fx-ccc">
                    {/* <div className="col-3 "></div> */}
                    <div className="col-10 fx-d-c fx-ccc">
                        <div className="col-3 fx-ccc">
                            {/* brand icon name */}
                            {/* <img src={common_images.LOGO_COMPANY_LOGIN} className="w-50" alt='Schematic diagram'/> */}
                            {(LOGOimg === null || LOGOimg === undefined) ?
                                <div className='empty-logoImg' data-content={t("GLOBAL.LOGOIMG")}>
                                    <div className='bdr-dashed lt'></div>
                                    <div className='bdr-dashed rt'></div>
                                    <div className='bdr-dashed lb'></div>
                                    <div className='bdr-dashed rb'></div>
                                </div> :
                                <img src={LOGOimg}
                                    style={{ width: `${LOGOimgWH[0]}px`, height: `${LOGOimgWH[1]}px` }}
                                    alt='Schematic diagram' />}
                        </div>
                        <div className="thirdParty fx-d-c fx-ccc inputBox">
                            <div className='w-100 fx-cspar font-ml thirdPartyTag outer tp l r'>
                                <div className={`fx-ccc outer_active l ${thirdPartyTag ? 'dismiss' : ''}`}
                                    onClick={() => { setThirdPartyTag(false) }}>
                                    <div className={`fx-ccc l ${thirdPartyTag ? '' : 'inner_active'}`}>{t("GLOBAL.ACCOUNT")} {t("GLOBAL.LOGIN")}</div>
                                </div>
                                <div className={`fx-ccc outer_active r ${thirdPartyTag ? '' : 'dismiss'}`}
                                    onClick={() => { setThirdPartyTag(true) }}>
                                    <div className={`fx-ccc r ${thirdPartyTag ? 'inner_active' : ''}`}>{t("GLOBAL.THIRD_PARTY")}</div>
                                </div>
                            </div>
                            {/* account */}
                            {thirdPartyTag ? <>
                                {/* <FBSDK /> */}
                                <div className='outer col-2 fx-ccc outer'><GoogleAuth /></div>
                                <div className='outer col-2 fx-ccc outer'><GoogleSDKLogout /></div>
                            </> : <>
                                <div className="font-l col-2 fx-ccc outer">
                                    <div className="w-90 bd-rad-lr bd-black pad-5 b t account_pointer"
                                        onMouseEnter={() => { setWrongAccOrPwd(false) }}
                                        onFocus={() => { setClickAccount(true); setWrongAccOrPwd(false) }}
                                        onKeyDown={(e) => { setClickAccount(true); login(e) }}
                                        onMouseLeave={() => { if (account === "") { setClickAccount(false) } }}>
                                        {(wrongAccOrPwd && storeLogin.responseState !== 0)
                                            ? (storeLogin.responseState === 422) ?
                                                <div className={` ${(wrongAccOrPwd) ? "wrong-pwd" : ""}`}>{t("GLOBAL.ACC_PWD_ERR")}</div>
                                                : (storeLogin.responseState === 404) ?
                                                    <div className={` ${(wrongAccOrPwd) ? "wrong-pwd" : ""}`}>該帳號已被登出</div>
                                                    : <div className={` ${(wrongAccOrPwd) ? "wrong-pwd" : ""}`}>{t("GLOBAL.SERVER_CONNECTION_ERR")}</div>
                                            : <>
                                                {clickAccount ? null : <div className={`email_input`}>{t("GLOBAL.ACCOUNT")}</div>}
                                                <input type="email"
                                                    value={account}
                                                    onChange={e => setAccount(e.target.value)}
                                                    className="w-75" />
                                            </>
                                        }
                                    </div>
                                </div>

                                {/* password */}
                                <div className="font-l col-2 fx-ccc outer">
                                    <div className='w-90 bd-rad-lr bd-black pad-5 b t account_pointer'
                                        onMouseEnter={() => { setWrongAccOrPwd(false) }}
                                        onFocus={() => { setClickPassword(true); setWrongAccOrPwd(false) }}
                                        onKeyDown={(e) => { setClickPassword(true); login(e) }}
                                        onMouseLeave={() => { if (password === "") { setClickPassword(false) } }}
                                    >
                                        {(wrongAccOrPwd && storeLogin.responseState !== 0) ?
                                            (storeLogin.responseState === 422) ?
                                                <div className={` ${(wrongAccOrPwd) ? "wrong-pwd" : ""}`}>{t("GLOBAL.ACC_PWD_ERR")}</div>
                                                : (storeLogin.responseState === 404) ?
                                                    <div className={` ${(wrongAccOrPwd) ? "wrong-pwd" : ""}`}>該帳號已被登出</div>
                                                    : <div className={` ${(wrongAccOrPwd) ? "wrong-pwd" : ""}`}>{t("GLOBAL.SERVER_CONNECTION_ERR")}</div>
                                            : <>
                                                {clickPassword ? null : <div className={`email_input type`}>{t("GLOBAL.PASSWORD")}</div>}
                                                <input type="password"
                                                    value={password}
                                                    onChange={e => setPassword(e.target.value)}
                                                    className="w-75" />
                                            </>}
                                    </div>
                                </div>
                            </>}
                            {/* login */}
                            <div className="font-l col-2 fx-ccc outer">
                                <div className="w-90 fx-d-r fx-fec">
                                    <div className="w-50 bd-rad-lr bd-black pad-5 b t account_pointer login"
                                        onClick={() => { login("Enter") }}>
                                        {t("GLOBAL.LOGIN")}
                                    </div>
                                </div>

                            </div>

                            {/* choose language */}
                            <div className="col-2 fx-ccc outer btm">
                                <div className="w-90 pad-15 r font-l">
                                    <Dropdown
                                        index={"0"}
                                        data={DP_data}
                                        selected={returnLng}
                                        toggleDropdown={toggleDropdown}
                                        closeToggle={dropdown_open}
                                        returnData={setReturnLng} />
                                </div>
                            </div>

                            {/* login */}
                        </div>
                        <div className="w-100 h-5 fx-cfe">{markC} {year} {t("GLOBAL.BRAND")}</div>
                    </div>
                    {/* <div className="col-3 "></div> */}

                </div>
            </div>
        </div>
    );

}
export default Login;

function useWindowSize() {
    const [size, setSize] = useState([window.innerWidth, window.innerHeight, window.innerWidth / 1920, window.innerHeight / 969]);
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight, window.innerWidth / 1920, window.innerHeight / 969])
        }
        window.addEventListener('resize', updateSize)
        return () => window.addEventListener('resize', updateSize)
    }, [])
    return size
}